import { OrdersView } from "../../components";

export const Orders = () => {
  return (
    <div className="container__pages">
      <h2>Registro de Pedidos</h2>
      <div className="container_form">
        <OrdersView />
      </div>
    </div>
  );
};
